import type { ReactNode } from 'react';
import { Box, Center, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { Logo } from '@web/ui/Logo';
import { ColorSchemeToggle, LanguageToggle } from '@web/theme/toggles';

/** Centered card used by every unauthenticated page. */
export function AuthLayout({
  title,
  subtitle,
  children,
  width = 440,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  width?: number;
}) {
  return (
    <Box mih="100dvh" bg="var(--mantine-color-body)" style={{ display: 'flex', flexDirection: 'column' }}>
      <Group justify="space-between" p="md">
        <Logo />
        <Group gap={4}>
          <LanguageToggle />
          <ColorSchemeToggle />
        </Group>
      </Group>
      <Center style={{ flex: 1 }} px="md" pb="xl">
        <Paper component="main" withBorder shadow="sm" radius="lg" p={{ base: 'lg', sm: 'xl' }} w="100%" maw={width}>
          <Stack gap="md">
            <div>
              <Title order={2} size="h3">
                {title}
              </Title>
              {subtitle && (
                <Text c="dimmed" size="sm" mt={4}>
                  {subtitle}
                </Text>
              )}
            </div>
            {children}
          </Stack>
        </Paper>
      </Center>
    </Box>
  );
}
